module.exports = __webpack_public_path__ + "vue_assets/img/img_setting_spacetravel.7a54deb6.png";